import { useOrderPanelStore } from '../../stores/order-panel-store'
import clsx from 'clsx'

const QUICK_PERCENTAGES = [0, 10, 25, 50, 100]

const PRESET_REASONS = [
  'Klacht — herreiniging',
  'Commerciële korting',
  'Medewerkerkorting',
  'Coulance',
  'Anders',
]

export function DiscountControl() {
  const discountPercentage = useOrderPanelStore((s) => s.discountPercentage)
  const discountReason = useOrderPanelStore((s) => s.discountReason)
  const setDiscount = useOrderPanelStore((s) => s.setDiscount)

  const isCustomReason = discountReason !== '' && !PRESET_REASONS.includes(discountReason) && discountReason !== 'Anders'
  const selectedPreset = isCustomReason ? 'Anders' : (PRESET_REASONS.includes(discountReason) ? discountReason : '')

  return (
    <div className="space-y-3">
      <label className="text-xs font-medium text-slate-600 block">Korting</label>

      {/* Quick percentage buttons */}
      <div className="flex gap-1.5">
        {QUICK_PERCENTAGES.map((pct) => (
          <button
            key={pct}
            onClick={() => setDiscount(pct, pct === 0 ? '' : discountReason)}
            className={clsx(
              'px-3 py-1.5 text-sm rounded-md border transition-colors flex-1',
              discountPercentage === pct
                ? pct === 100
                  ? 'border-red-500 bg-red-50 text-red-700'
                  : 'border-indigo-500 bg-indigo-50 text-indigo-700'
                : 'border-slate-200 text-slate-600 hover:border-slate-300'
            )}
          >
            {pct}%
          </button>
        ))}
      </div>

      {/* Custom percentage input */}
      {!QUICK_PERCENTAGES.includes(discountPercentage) && discountPercentage > 0 && (
        <div className="flex items-center gap-2">
          <input
            type="number"
            min={0}
            max={100}
            value={discountPercentage}
            onChange={(e) => setDiscount(Math.min(100, Math.max(0, parseInt(e.target.value) || 0)), discountReason)}
            className="w-20 px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
          <span className="text-sm text-slate-500">%</span>
        </div>
      )}

      {/* 100% badge */}
      {discountPercentage === 100 && (
        <div className="px-3 py-1.5 bg-red-50 border border-red-200 rounded-md text-xs text-red-700 font-medium">
          Gratis — klachtafhandeling
        </div>
      )}

      {/* Reason (shown when discount > 0) */}
      {discountPercentage > 0 && (
        <div className="space-y-2">
          <label className="text-xs font-medium text-slate-600 block">
            Reden <span className="text-red-500">*</span>
          </label>
          <select
            value={selectedPreset}
            onChange={(e) => {
              const val = e.target.value
              setDiscount(discountPercentage, val === 'Anders' ? '' : val)
            }}
            className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">Kies een reden...</option>
            {PRESET_REASONS.map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>

          {/* Free text for "Anders" */}
          {(selectedPreset === 'Anders' || isCustomReason) && (
            <input
              type="text"
              placeholder="Vul reden in..."
              value={isCustomReason ? discountReason : ''}
              onChange={(e) => setDiscount(discountPercentage, e.target.value)}
              className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          )}

          {/* Validation hint */}
          {discountPercentage > 0 && !discountReason && (
            <p className="text-xs text-amber-600">Vul een reden in voor de korting</p>
          )}
        </div>
      )}
    </div>
  )
}
